import { render, staticRenderFns } from "./Text2.vue?vue&type=template&id=24f89520&scoped=true"
import script from "./Text2.vue?vue&type=script&lang=js"
export * from "./Text2.vue?vue&type=script&lang=js"
import style0 from "./Text2.vue?vue&type=style&index=0&id=24f89520&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f89520",
  null
  
)

export default component.exports